import {
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaLinkedinIn,
} from "react-icons/fa";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <div className="w-full mygray text-white py-10 md:px-20 px-5 bg-black">
      {/* <div className="max-w-[1240px] mx-auto grid grid-cols-2 md:grid-cols-4 border-b border-white md:pt-16 md:pb-16 pb-10">
        <div className="col-span-2 md:px-0 px-4">
          <p className="font-bold uppercase">Subscribe to our newsletter</p>
          <p className="py-4" style={{ color: "white", fontSize: "12px" }}>
            The latest news, articles, and resources, sent to your inbox weekly.
          </p>
          <form className="md:flex  items-center">
            <input
              className="w-full p-2 md:mr-4 rounded-md mb-4"
              type="email"
              placeholder="Enter email.."
            />
            <button
              className=" p-2 mb-4 rounded-md text-white border border-white"
              style={{ backgroundColor: "#000" }}
            >
              Subscribe
            </button>
          </form>
        </div>
      </div> */}
      <div className="md:flex flex-col-reserve max-w-[1240px] px-2 py-4 mx-auto justify-between text-center text-white text-sm">
        <p className="py-4 font-light">
          RemotewebNET Dynamics Ltd @ 2023 All rights reserved
        </p>
        <div className="flex  space-x-4 md:justify-end justify-start md:mb-0 mb-5 sm:w-[300px] pt-4 text-2xl">
          <a href={"https://www.linkedin.com/company/remotewebnet/"}>
            <FaLinkedinIn />
          </a>
          <FaTwitter />
        </div>
      </div>
    </div>
  );
};

export default Footer;
